export default "__VITE_ASSET__930fdd8b__"